import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    text: 'Itaobuy Spreadsheet ha completamente cambiato il mio modo di fare shopping online. Le liste sono sempre aggiornate e le categorie sono organizzate in modo impeccabile. Lo consiglio a tutti gli appassionati di moda.',
    name: 'Marco R.',
    source: 'Milano, Italia',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Italian%20man%20late%2020s%20with%20stylish%20stubble%20beard%20wearing%20a%20linen%20shirt%2C%20warm%20golden%20hour%20lighting%20on%20a%20terracotta%20balcony%2C%20genuine%20smile%2C%20blurred%20Mediterranean%20coastline%20background%2C%20editorial%20portrait%20photography%20with%20natural%20warmth&width=200&height=200&seq=avatar-marco-v2&orientation=squarish',
  },
  {
    id: 2,
    text: 'Finalmente un sito italiano che spiega come funziona Itaobuy Spreadsheet in modo chiaro e semplice. Le guide sono dettagliate e mi hanno aiutato a trovare prodotti incredibili a prezzi convenienti.',
    name: 'Giulia B.',
    source: 'Roma, Italia',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Italian%20woman%20early%2030s%20with%20elegant%20dark%20hair%20wearing%20a%20silk%20blouse%2C%20soft%20studio%20lighting%20with%20gentle%20rim%20light%2C%20confident%20warm%20expression%2C%20clean%20sage%20green%20background%2C%20sophisticated%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-giulia-v2&orientation=squarish',
  },
  {
    id: 3,
    text: 'Utilizzo Itaobuy Spreadsheet da mesi e non potrei più farne a meno. Le 14 categorie coprono tutto ciò di cui ho bisogno. Il sito è diventato la mia risorsa di riferimento per lo shopping.',
    name: 'Alessandro F.',
    source: 'Napoli, Italia',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Italian%20man%20mid%2020s%20with%20casual%20charm%20wearing%20a%20navy%20polo%20shirt%2C%20afternoon%20sunlight%20filtering%20through%20olive%20trees%2C%20relaxed%20genuine%20smile%2C%20rustic%20countryside%20backdrop%2C%20lifestyle%20portrait%20photography%20with%20cinematic%20warmth&width=200&height=200&seq=avatar-alessandro-v2&orientation=squarish',
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const goNext = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const goPrev = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const t = testimonials[current];

  return (
    <section className="w-full bg-background-50 py-16 md:py-20 px-4 md:px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 italic">
            (Dicono di Noi)
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex items-start gap-1 mb-6">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground-950 text-background-50 text-xs font-semibold">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              4.9 / 5.0
            </span>
          </div>

          <blockquote className="font-heading text-xl md:text-2xl italic text-foreground-800 leading-relaxed mb-8 min-h-[120px]">
            &ldquo;{t.text}&rdquo;
          </blockquote>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.source}</p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={goPrev}
                className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-200 text-foreground-600 hover:bg-foreground-50 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-sm"></i>
              </button>
              <button
                onClick={goNext}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-1.5 mt-8">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={'w-2 h-2 rounded-full transition-all cursor-pointer ' + (i === current ? 'bg-foreground-800 w-5' : 'bg-foreground-300')}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}